<template>
  <div class="blankForm">
    表单开发中...
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    // 接口：用于获取表单数据
    getFormData() {
      return {};
    },

    // 接口：设置表单数据
    setFormData() {},

    // 接口：校验表单数据
    validateFormData() {
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.blankForm {
  height: 100px;
  text-align: center;
}
</style>
